import React from 'react';
import DownloadsListItem from "./DownloadsListItem";
import {DownloadItem} from "../types/downloadItem";
import {AppState} from "../apps/Downloads";
import {useTranslation} from "../hooks/useTranslation";
import DownloadsListLoadMore from "./DownloadsListLoadMore";

type DownloadsListProps = {
    downloads : DownloadItem[]
    appState : AppState
    loadMore : (event: React.MouseEvent<HTMLElement>) => void
    moreAvailable : boolean
}

function DownloadsList({downloads, appState, loadMore, moreAvailable} : DownloadsListProps) {

    const translate = useTranslation();

    return (
        <div className="downloadsOverview__list">
            <div className="downloadsOverview__list--header">
                <div  className="downloadsOverview__list-header-title">
                    <span>{translate('downloads.list.header.title')}</span>
                </div>

                <div  className="downloadsOverview__list-header-download">
                     <span>{translate('downloads.list.header.download')}</span>
                </div>
            </div>

            {downloads.length === 0 &&
                <div className={`downloadsOverview__list--noResults ${appState === AppState.loading ? 'isLoading' : ''}`}>
                    {translate('downloads.no.results')}
                </div>
            }
            {appState === AppState.loading && <span className='downloadsOverview__list--loader' />}

            {downloads.map((downloadItem, index) => <DownloadsListItem key={index} downloadItem={downloadItem} />)}

            { moreAvailable && <DownloadsListLoadMore loadMore={loadMore} /> }
        </div>
    );
}

export default DownloadsList;
